import {ReactComponent as CrossIcon} from 'icons/cross.svg'

type Props = {
  onClose: () => void
  title: string
}

export const Header = ({onClose, title}: Props) => {
  return (
    <div className="flex justify-between px-4 py-6 d:px-8 d:py-4 border-solid border-solid border-b border-gray-3 items-center">
      <h3 className="font-extrabold leading-5 text-base">{title}</h3>
      <CrossIcon className="cursor-pointer" onClick={onClose} />
    </div>
  )
}
